import { BillingSubscription } from "../../../types/subscription";

export default function RecentTransactions({ subscriptions }: { subscriptions: BillingSubscription[] }) {
    // Format date as yyyy-mm-dd
    const formatDate = (date: Date) => {
        const options: Intl.DateTimeFormatOptions = {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
        };
        return date.toLocaleString("en-US", options);
    };


    return (
        <div className="flex flex-col items-start justify-start">
            <p className="text-white text-lg font-bold my-2">Recent Transactions</p>

            <div className="w-full bg-card rounded-xl p-4 overflow-y-auto h-[300px]">
                <table className="w-full">
                    <thead className="border-b border-gray-400 text-xs text-gray-200">
                        <tr>
                            <th className="text-center font-light py-2">User</th>
                            <th className="text-center font-light py-2">Date</th>
                            <th className="text-center font-light py-2">Service</th>
                            <th className="text-center font-light py-2">Package</th>
                            <th className="text-center font-light py-2">Amount</th>
                            {/* <th className="text-center font-light">Method</th> */}
                            <th className="text-center font-light py-2">Payer ID</th>
                            <th className="text-center font-light py-2">Status</th>
                            <th className="text-center font-light py-2">Receipt</th>

                        </tr>
                    </thead>

                    <tbody className="text-white text-xs">
                        {subscriptions.map((subscription, index) => (
                            <tr key={index} className={index % 2 === 0 ? "bg-card/50" : "bg-card/30"}>
                                <td className="text-center py-2">{subscription.username}</td>
                                <td className="text-center py-2">{formatDate(new Date(subscription.renewed_at))}</td>
                                <td className="text-center py-2">{subscription.service_name}</td>
                                <td className="text-center py-2">{subscription.package_name}</td>
                                <td className="text-center py-2">{subscription.price}</td>
                                <td className="text-center py-2">{subscription.payerid}</td>
                                <td className={`text-center py-2 ${subscription.status === "paid" ? "text-green-500" : "text-red-500"}`}>{subscription.status}</td>
                                <td className="text-center py-2">
                                    <button className="bg-none border border-white text-white rounded-lg py-1 px-2 hover:scale-105 cursor-pointer">Download</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}